import { Trans, useTranslation } from 'react-i18next'
import { useWeb3React } from '@web3-react/core'
import NotificationBar from '~/components/NotificationBar'
import { useSettlementFeeValidator } from '~/components/Exchange/hooks'
import { PriceImpactLevel, useSpotSwapPriceImpact } from '~/state/dex/hooks'
import CrossAmountExceedingWarning from './CrossAmountExceedingWarning'

interface Props {
  isNoQuote: boolean
  minAmountOut: bigint
  inputAmount: string
  hasTokenPrice?: boolean
}

const OrderWarning: React.FC<Props> = ({
  isNoQuote,
  minAmountOut,
  inputAmount,
  hasTokenPrice = true,
}) => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const priceImpactInfo = useSpotSwapPriceImpact()

  const isWalletConnected = !!account
  const isSettlementFeeValid = useSettlementFeeValidator(minAmountOut)

  return (
    <>
      <CrossAmountExceedingWarning inputAmount={inputAmount} />
      {isWalletConnected && (
        <>
          {isNoQuote && (
            <NotificationBar
              level="risk"
              text={t('spotswap_swap_no_quote_alert')}
              showIcon={false}
              showLink={false}
              showClose={false}
              style={{ marginTop: 16 }}
            />
          )}
          {!isSettlementFeeValid && (
            <NotificationBar
              level="warning"
              text={t('spotswap_swap_amount_too_low_alert')}
              showIcon={false}
              showLink={false}
              showClose={false}
            />
          )}

          {hasTokenPrice && priceImpactInfo?.level === PriceImpactLevel.DANGER && (
            <NotificationBar
              style={{ marginTop: 16 }}
              level="risk"
              text={
                <Trans
                  i18nKey="spotswap_swap_price_impact_too_high_alert"
                  values={{
                    percentage: priceImpactInfo.priceImpactInPercent,
                    usdValue: Math.abs(
                      Number(priceImpactInfo.priceImpactInUsd),
                    ),
                  }}
                  components={{
                    bold: <span style={{ fontWeight: 700 }} />,
                  }}
                />
              }
              showIcon={true}
              showLink={false}
              showClose={false}
            />
          )}
        </>
      )}
    </>
  )
}

export default OrderWarning
